import { render } from "./KindergartenCard.vue?vue&type=template&id=704b613a&scoped=true"
import script from "./KindergartenCard.vue?vue&type=script&lang=js"
export * from "./KindergartenCard.vue?vue&type=script&lang=js"

import "./KindergartenCard.vue?vue&type=style&index=0&id=704b613a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-704b613a"]])

export default __exports__